export const defaultError = [
  'error',
  'Ocorreu um erro ao carregar os dados do produto',
  'Tente novamente mais tarde',
] as const;
